import React from "react";
import { StatusToggleSwitch } from "../StatusToggleSwitch";
import { textPublisherListing } from "../../redux/features/mastersSlice";

export const TextPublisherListingStatus = ({ params }) => {
    return (
        <div>
            <StatusToggleSwitch
                initialValue={params.is_listed}
                api={textPublisherListing(params.text_publisher_id)}
            />
        </div>
    );
};
